import { formatCurrency } from '../utils/currency'
import { formatDate } from '../utils/date'

export function formatRate(rate: string | number, useCents: boolean, currencyPrefix = '') {
  const formattedRate = formatCurrency(Number(rate), useCents, currencyPrefix)

  return Number(rate) > 0 ? formattedRate : ''
}

// This is done because the rate per distance (mile or kilometers) is being
// formatted using the formatCurrency util using cents
export function formatRatePerDistance(ratePerDistance: number) {
  return ratePerDistance / 10 ** 2
}

export function formatRateSubmittedDateTime(date?: Date) {
  return date ? formatDate(date, 'MMM d - h:mm a') : ''
}
